import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import routes from 'routes/index';
import privateRoutes from 'routes/private.index';
import PublicRoute from 'routes/PublicRoute';
import NotFound from 'components/notFound/NotFound';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'App.scss';
import PrivateRoute from 'routes/AuthRoute';
import { useDispatch } from 'react-redux';
import { broadCastStorage } from './helpers/utils';
import { setSelectedBroadCast } from './store/actions/conversation.actions';

function App() {
  document.title = 'Social Play';
  const dispatch = useDispatch();
  useEffect(() => {
    const broadCast = broadCastStorage.get();
    if (broadCast) {
      dispatch(setSelectedBroadCast(broadCast));
    }
  }, []);
  useEffect(() => {
    // @ts-ignore
    window.process = {...window.process};
  }, []);
  return (
    <div className="App">
      <div>
        <Switch>
          {privateRoutes &&
          privateRoutes.map((route, key) => <PrivateRoute key={key} path={route.path} component={route.component} />)}
          {routes &&
            routes.map((route, key) => <PublicRoute key={key} path={route.path} component={route.component} />)}
          <Redirect exact from="/" to="/login" />
          <Route component={NotFound} />
        </Switch>
      </div>
      <ToastContainer hideProgressBar />
    </div>
  );
}

export default App;
